"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prettyPrintNumberWithNoZeros = exports.prettyPrintNumber = void 0;
const numeral_1 = __importDefault(require("numeral"));
function prettyPrintNumber(num) {
    if (num < 1000) {
        return num.toString();
    }
    // try to get 3 significant digits
    const len = num.toString().length % 3;
    if (len === 0) {
        return (0, numeral_1.default)(num).format("0a");
    }
    if (len === 1) {
        return (0, numeral_1.default)(num).format("0.00a");
    }
    return (0, numeral_1.default)(num).format("0.0a");
}
exports.prettyPrintNumber = prettyPrintNumber;
function prettyPrintNumberWithNoZeros(num) {
    if (num < 1000) {
        // todo: should retrun 0 instead of undefined, once the icon for engagement stats is fixed.
        return undefined;
    }
    // try to get 3 significant digits without any zeros
    const len = num.toString().substring(0, 3).replace(/0+$/, "").length;
    if (num > 1000000000) {
        if (len <= 1) {
            return (0, numeral_1.default)(num).format("0a");
        }
        return (0, numeral_1.default)(num).format("0.0a");
    }
    return (0, numeral_1.default)(num).format("0a");
}
exports.prettyPrintNumberWithNoZeros = prettyPrintNumberWithNoZeros;
//# sourceMappingURL=numbers.js.map